import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
// import { NewSiteWizard } from "../components/new-site-wizard";
import { subProductsBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewProductForm } from "../components/new-product-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subProductsBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewProduct({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/products");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create Product" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewProductForm resource="Product" url="products" flashbar={state.flashBar}/>
  );
}
